import mixpanel from "mixpanel-browser";

if (process.env.REACT_APP_MIXPANEL_TOKEN) {
    mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);
}

export const mixpanelHelper = mixpanel;
